import styled from 'styled-components';

export const Container = styled.div`
    && {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
`;

export const YatHandContainer = styled.div`
    && {
        flex: 0 0 auto;
        margin-bottom: 30px;

        svg {
            display: inline-block;
            flex-shrink: 0;
            vertical-align: middle;
            max-width: 100%;
            overflow: hidden;
            fill: currentColor;
            box-sizing: border-box;
            width: auto;
            height: 1em;
            user-select: none;
            font-size: 8.4375rem;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
            margin-bottom: 60px;
        }
    }
`;

export const Heading = styled.h3`
    && {
        font-family: 'Alliance No.1';
        font-style: normal;
        font-weight: 700;
        font-size: 1.4rem;
        line-height: 1;
        letter-spacing: -0.05em;
        padding: 0;
        margin: 0 0 10px 0;
        color: ${({ theme }) => theme.colors.white};
        max-width: 600px;

        @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
            font-size: 1.875rem;
        }
    }
`;

export const SubHeading = styled.p`
    && {
        font-family: 'Alliance No.1';
        font-style: normal;
        font-weight: 400;
        font-size: 1.2rem;
        line-height: 1.3;
        letter-spacing: -0.03em;
        margin: 0;
        padding: 0;
        color: ${({ theme }) => theme.shades.white[50]};
        max-width: 600px;
        white-space: pre-line;
        @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
            font-size: 1.5rem;
        }
    }
`;
